var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "selector-container" },
    [
      _vm.hasSkills
        ? _c(
            "vs-row",
            { staticClass: "mb-6" },
            [
              _c(
                "vs-col",
                { attrs: { "vs-w": "12" } },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: {
                      name: "JobFilterOccupationSkills",
                      placeholder: "Filtrer les Savoir-faire affichés...",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("vs-row", [
        _c("span", { staticClass: "vs-col" }, [
          _vm._v(
            "\n            Glissez-déposez les Savoir-faire que vous souhaitez ajouter :\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasSkills
        ? _c(
            "vs-row",
            { staticClass: "mt-5" },
            [
              _c(
                "vs-col",
                { attrs: { "vs-w": "5.5" } },
                [
                  _c(
                    "vs-list",
                    [
                      _c("vs-list-header", {
                        attrs: {
                          title: "Savoir-faire disponibles",
                          color: "primary",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "vs-list",
                        { staticClass: "scrollable_list" },
                        [
                          _vm._l(_vm.sectorsSkills, function (listItem, i) {
                            return [
                              _c("vs-list-header", {
                                key: i,
                                attrs: { color: "primary", title: i },
                              }),
                              _vm._v(" "),
                              _c(
                                "draggable",
                                {
                                  key: "drag-" + i,
                                  staticClass: "p-2 cursor-move",
                                  attrs: {
                                    value: _vm.sectorsSkills[i],
                                    group: "skills",
                                  },
                                },
                                _vm._l(listItem, function (skill, j) {
                                  return _c("vs-list-item", {
                                    key: i + "-" + j,
                                    attrs: {
                                      id: "occupationSkill_" + skill.id,
                                      title:
                                        skill.title +
                                        (skill.establishment
                                          ? " - " + skill.establishment.name
                                          : ""),
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          }),
                          _vm._v(" "),
                          !Object.keys(_vm.sectorsSkills).length
                            ? [
                                _c("draggable", {
                                  staticClass: "p-2 cursor-move",
                                  attrs: {
                                    value: [],
                                    group: "skills",
                                    emptyInsertThreshold: 250,
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "vs-col",
                  {
                    attrs: {
                      "vs-type": "flex",
                      "vs-justify": "center",
                      "vs-align": "center",
                      "vs-w": "1",
                    },
                  },
                  [
                    _c("chevrons-right-icon", {
                      staticClass: "custom-class",
                      attrs: { size: "3x", stroke: "rgb(var(--vs-primary))" },
                    }),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              _c(
                "vs-col",
                { attrs: { "vs-w": "5.5" } },
                [
                  _c(
                    "vs-list",
                    [
                      _c("vs-list-header", {
                        attrs: {
                          title: `Savoir-faire choisis`,
                          color: "primary",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          staticClass: "p-2 cursor-move scrollable_list",
                          attrs: {
                            group: "skills",
                            emptyInsertThreshold: 250,
                            direction: "horizontal",
                          },
                          on: { input: _vm.onSelectedSkillsChange },
                          model: {
                            value: _vm.selected,
                            callback: function ($$v) {
                              _vm.selected = $$v
                            },
                            expression: "selected",
                          },
                        },
                        _vm._l(_vm.selected, function (listItem, i) {
                          return _c("vs-list-item", {
                            key: listItem.id + "-" + i,
                            attrs: {
                              id: "occupationSkillSelected_" + listItem.id,
                              title:
                                listItem.title +
                                (listItem.establishment
                                  ? " - " + listItem.establishment.name
                                  : ""),
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm.occupationSkillsLoading || _vm.establishmentsLoading
        ? _c("vs-row", { staticClass: "selector-container empty" }, [
            _c("p", [_vm._v("Chargement en cours...")]),
          ])
        : _c("vs-row", { staticClass: "selector-container empty" }, [
            _c("p", [_vm._v("Aucun savoir-faire n'a encore été créé")]),
            _vm._v(" "),
            _c("a", { on: { click: _vm.redirect } }, [
              _vm._v("Ajouter un nouveau savoir-faire"),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }